import React from "react";
import Grid from "@mui/material/Grid";




const DivisionCardUserCmp = (props: any) => {
  return (
    <>
      <div style={{ margin: "0px 10px 0px 10px" }}>
        <div className="cardBorder borderCOlor mTop20">
          <Grid container  className="row" spacing={2} style={{ alignItems: 'center', width: "98%", margin: "auto" }}>
            <Grid item style={{ alignItems: 'left', paddingTop: '20px',minWidth:'22vh' }} >
              <div>
                <div className="divisionCardCmp" style={{ lineHeight: '1.9',marginLeft:'-2vh' }}>
                  <div
                    className="colorTitle textFont14 "style={{maxWidth:'50vh',marginRight:'-1vh'}} >
                    {props.titleCard}
                  </div>

                </div>

              </div>

            </Grid>
            <Grid item
            style={{
                  alignItems: "right",
                  paddingTop: "20px",
                  maxWidth: "20vh",
                  minWidth: "10vh",
                  marginRight:"2vh",
                  
                }} >
              <img
                className="designCard divisionCardTitle"
                src='images/account icon.png'
                alt="Red dot"
              />
            </Grid>
            <Grid item xs={12}  sm container style={{ textAlign: "right", paddingTop: '20px', fontSize: "14px", lineHeight: '2.5' ,marginRight:'3vh'}}>
              <Grid style={{ textAlign: "right" }} xs={12}>
                {/* <Grid style={{ textAlign: "right", fontSize: "14px" }} > */}
                <span >  نام و نام خانوادگی:  </span>
                <span style={{ marginLeft: '10px', fontWeight: 'bold' }}>
                  {props.value.firstName + ' ' + props.value.lastName}&nbsp;&nbsp;
                </span>
                |
                <span style={{ marginRight: '10px' }}>
                  کد ملی:
                </span>
                <span style={{ fontWeight: 'bold' }}>&nbsp;&nbsp;{props.value.nationalCode}&nbsp;&nbsp;</span>
                |
                <span style={{ marginRight: '10px' }}>
                  تاریخ تولد:
                </span>
                <span style={{ fontWeight: 'bold' }}>&nbsp;&nbsp;{props.value.birthDate_Persian}&nbsp;&nbsp;</span>
                |
                <span style={{ marginRight: '10px' }}>
                  شماره موبایل:
                </span>
                <span style={{ fontWeight: 'bold' }}>&nbsp;&nbsp;{props.value.cellPhone}&nbsp;&nbsp;</span>
                |
                <span style={{ marginRight: '10px' }}>
                  کدپستی:
                </span>
                <span style={{ fontWeight: 'bold' }}>&nbsp;&nbsp;{props.value.postalCode}&nbsp;&nbsp;</span>
                |
                <span style={{ marginRight: '10px' }}>
                  آدرس پستی استعلامی:
                </span>
                <span style={{ fontWeight: 'bold' }}>&nbsp;&nbsp;{props.value.address}&nbsp;&nbsp;</span>
                {/* </Grid> */}
              </Grid>
            </Grid>
          </Grid>
        </div>
      </div>
      {/* })} */}
    </>
  );
};

export default DivisionCardUserCmp;
